import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import { looseDiamondId, looseStoneId } from "utils/helpers";

const data4 = [
  {
    srNo: "01",
    itemDetails: "Purchase Gold, Bangles, Navratna Bang, BN100",
    totalWt: "100.000",
    grossWt: "800.000",
    stoneWt: "000.000",
    netWt: "000.000",
    finePercent: "10",
    wastagePercent: "10",
    fPlusWWt: "120.000",
    ratePer10Gm: "80000.00",
    stoneAmt: "5000.00",
    qty: "2",
    hallmarkAmt: "100",
    totalItemAmt: "50,00,000.00",
    packingWt: "10.000",
    diamondWt: "121.000",
  },
  {
    srNo: "02",
    itemDetails: "Purchase",
    totalWt: "100.000",
    grossWt: "200.000",
    stoneWt: "000.000",
    netWt: "000.000",
    finePercent: "10",
    wastagePercent: "10",
    fPlusWWt: "120.000",
    ratePer10Gm: "80000.00",
    stoneAmt: "5000.00",
    qty: "4",
    hallmarkAmt: "100",
    totalItemAmt: "50,00,000.00",
    packingWt: "20.000",
    diamondWt: "121.000",
  },
  {
    srNo: "03",
    itemDetails: "Purchase",
    totalWt: "100.000",
    grossWt: "200.000",
    stoneWt: "000.000",
    netWt: "000.000",
    finePercent: "10",
    wastagePercent: "10",
    fPlusWWt: "120.000",
    ratePer10Gm: "80000.00",
    stoneAmt: "5000.00",
    qty: "4",
    hallmarkAmt: "100",
    totalItemAmt: "50,00,000.00",
    packingWt: "20.000",
    diamondWt: "121.000",
  },
  {
    srNo: "04",
    itemDetails: "Purchase",
    totalWt: "100.000",
    grossWt: "200.000",
    stoneWt: "000.000",
    netWt: "000.000",
    finePercent: "10",
    wastagePercent: "10",
    fPlusWWt: "120.000",
    ratePer10Gm: "80000.00",
    stoneAmt: "5000.00",
    qty: "4",
    hallmarkAmt: "100",
    totalItemAmt: "50,00,000.00",
    packingWt: "20.000",
    diamondWt: "121.000",
  },
];
const totals = data4.reduce(
  (acc, row) => {
    acc.totalWt += parseFloat(row.totalWt);
    acc.grossWt += parseFloat(row.grossWt);
    acc.stoneWt += parseFloat(row.stoneWt);
    acc.netWt += parseFloat(row.netWt);
    acc.finePercent += parseFloat(row.finePercent);
    acc.wastagePercent += parseFloat(row.wastagePercent);
    acc.fPlusWWt += parseFloat(row.fPlusWWt);
    acc.stoneAmt += parseFloat(row.stoneAmt);
    acc.qty += parseFloat(row.qty);
    acc.hallmarkAmt += parseFloat(row.hallmarkAmt);
    acc.totalItemAmt += parseFloat(row.totalItemAmt.replace(/,/g, ""));
    acc.packingWt += parseFloat(row.packingWt);
    acc.diamondWt += parseFloat(row.diamondWt);
    return acc;
  },
  {
    totalWt: 0,
    grossWt: 0,
    stoneWt: 0,
    netWt: 0,
    finePercent: 0,
    wastagePercent: 0,
    fPlusWWt: 0,
    stoneAmt: 0,
    qty: 0,
    hallmarkAmt: 0,
    totalItemAmt: 0,
    packingWt: 0,
    diamondWt: 0,
  }
);

const Summary = ({
  skus,
  setIsSummaryOpen,
  setValue,
  setEditValues,
  setEdit,
  VendorName
}) => {
  const [total, setTotal] = useState({
    TotalFineMetal: 0,
    TotalWastagePercent: 0,
    TotalFinePercent: 0,
    TotalNetWt: 0,
    TotalStoneWt: 0,
    TotalGrossWt: 0,
    TotalWt: 0,
    TotalRate: 0,
    TotalStoneAmount: 0,
    TotalQty: 0,
    TotalHallmark: 0,
    TotalItemAmount: 0,
    TotalPackingWt: 0,
    TotalDiamondWt: 0,
  });
  const handleDelete = (id) => {
    setValue(
      "skus",
      skus.filter((sku) => sku.id !== id)
    );
  };
  const handleEdit = (id) => {
    const data = skus.find((sku) => sku.id == id);
    console.log(data)
    setEditValues(data);
    setEdit(true);
    setIsSummaryOpen(false);
  };

  useEffect(() => {
    let totalFineMetal = 0;
    let wastagePercent = 0;
    let finePercent = 0;
    let netWt = 0;
    let stoneWt = 0;
    let grossWt = 0;
    let totalWt = 0;
    let totalRate = 0;
    let stoneAmount = 0;
    let qty = 0;
    let hallmark = 0;
    let itemAmt = 0;
    let packingWt = 0;
    let diamondWt = 0;

    skus?.forEach((item) => {
      totalFineMetal += +item?.FineWastageWt;
      wastagePercent += +item?.WastagePercent;
      finePercent += +item?.FinePercent;
      netWt += +item?.NetWt;
      stoneWt += +item?.StoneWt;
      grossWt += +item?.GrossWt;
      totalWt += +item?.TotalWt;
      totalRate += +item?.MetalRate;
      stoneAmount += +item?.StoneAmount;
      qty += +item?.Qty;
      hallmark += +item?.Hallmark;
      itemAmt += +item?.TotalItemAmount || +item?.TotalAmount;
      packingWt += +item?.PackingWeight;
      diamondWt += +item?.DiamondWeight;
    });
    setValue("TotalFineMetal", totalFineMetal?.toFixed(3));
    setValue("TotalTaxableAmount", itemAmt?.toFixed(3));
    setTotal({
      TotalFineMetal: totalFineMetal ? totalFineMetal : 0,
      TotalWastagePercent: wastagePercent ? wastagePercent : 0,
      TotalFinePercent: finePercent ? finePercent : 0,
      TotalNetWt: netWt ? netWt : 0,
      TotalStoneWt: stoneWt ? stoneWt : 0,
      TotalGrossWt: grossWt ? grossWt : 0,
      TotalWt: totalWt ? totalWt : 0,
      TotalRate: totalRate ? totalRate : 0,
      TotalStoneAmount: stoneAmount ? stoneAmount : 0,
      TotalQty: qty ? qty : 0,
      TotalHallmark: hallmark ? hallmark : 0,
      TotalItemAmount: itemAmt ? itemAmt : 0,
      TotalPackingWt: packingWt ? packingWt : 0,
      TotalDiamondWt: diamondWt ? diamondWt : 0,
    });
  }, [skus]);
  return (
    <div className="box1-section">
      <div
        className="table-container"
        style={{ overflowX: "auto", margin: "0", padding: "0", width: "100%" }}
      >
        <table className="custom-table">
          <thead>
            <tr>
              <th
                style={{
                  fontSize: "12px",
                  width: "300px",
                  minWidth: "300px",
                  textAlign: "left",
                  background: "#627282",
                  color: "#fff",
                }}
              >
                Item Details
              </th>
              <th
                style={{
                  fontSize: "12px",
                  background: "#627282",
                  color: "#fff",
                }}
              >
                Total Wt
              </th>
              <th
                style={{
                  fontSize: "12px",

                  background: "#627282",
                  color: "#fff",
                }}
              >
                Gross Wt
              </th>
              <th
                style={{
                  fontSize: "12px",
                  background: "#627282",
                  color: "#fff",
                }}
              >
                Stone Wt
              </th>
              <th
                style={{
                  fontSize: "12px",

                  background: "#627282",
                  color: "#fff",
                }}
              >
                Net Wt
              </th>
              <th
                style={{
                  fontSize: "12px",
                  background: "#627282",
                  color: "#fff",
                }}
              >
                Fine %
              </th>
              <th
                style={{
                  fontSize: "12px",
                  background: "#627282",
                  color: "#fff",
                }}
              >
                Wastage %
              </th>
              <th
                style={{
                  fontSize: "12px",
                  background: "#627282",
                  color: "#fff",
                }}
              >
                F+W Wt
              </th>
              <th
                style={{
                  fontSize: "12px",
                  background: "#627282",
                  color: "#fff",
                }}
              >
                Rate/Gm
              </th>
              <th
                style={{
                  fontSize: "12px",
                  background: "#627282",
                  color: "#fff",
                }}
              >
                Stone Amt
              </th>
              <th
                style={{
                  fontSize: "12px",
                  background: "#627282",
                  color: "#fff",
                }}
              >
                Qty
              </th>
              <th
                style={{
                  fontSize: "12px",
                  background: "#627282",
                  color: "#fff",
                }}
              >
                HallMark Amt
              </th>
              <th
                style={{
                  fontSize: "12px",
                  background: "#627282",
                  color: "#fff",
                }}
              >
                Total Item Amt
              </th>
              <th
                style={{
                  fontSize: "12px",
                  background: "#627282",
                  color: "#fff",
                }}
              >
                Packing Wt
              </th>
              <th
                style={{
                  fontSize: "12px",
                  background: "#627282",
                  color: "#fff",
                }}
              >
                Diamond Wt
              </th>
            </tr>
          </thead>
          <tbody>
            {skus.map((row) => (
              <tr key={row.srNo}>
                <td>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "12px",
                      // gap: "5px",
                    }}
                  >
                    <Icon
                      icon="lets-icons:img-box-fill"
                      width="24"
                      height="24"
                      style={{ flex: "1", color: "#627282", cursor: "pointer" }}
                    />
                    <div style={{ flex: "1" }}>
                      {row?.CategoryId?.value !== looseStoneId &&
                      row?.CategoryId?.value !== looseDiamondId ? (
                        <>
                          {row?.CategoryId?.label} - {row?.ProductId?.label} -{" "}
                          {row?.DesignId?.label} - {row?.PurityId?.label}
                        </>
                      ) : row?.CategoryId?.value == looseStoneId ||
                        row?.CategoryId?.value == looseDiamondId ? (
                        row?.CategoryId?.label
                      ) : (
                        ""
                      )}
                    </div>
                    <div
                      style={{
                        flex: "1",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <div
                        style={{ display: "flex", flexDirection: "column" }}
                        title="edit"
                        onClick={() => handleEdit(row.id)}
                      >
                        <Icon
                          title="edit"
                          icon="material-symbols-light:edit-outline"
                          width="15"
                          height="15"
                          style={{ color: "#627282", cursor: "pointer" }}
                        />
                      </div>
                      <div
                        style={{ display: "flex", flexDirection: "column" }}
                        title="delete"
                      >
                        <Icon
                          icon="weui:delete-outlined"
                          width="15"
                          height="15"
                          style={{ color: "#627282", cursor: "pointer" }}
                          onClick={() => {
                            handleDelete(row.id);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </td>
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {(+row?.TotalWt || 0)?.toFixed(3)}
                </td>
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {(+row?.GrossWt || 0)?.toFixed(3)}
                </td>
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {(+row?.StoneWt || 0)?.toFixed(3)}
                </td>
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {(+row?.NetWt || 0)?.toFixed(3)}
                </td>
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {row?.FinePercent}
                </td>
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {row?.WastagePercent}
                </td>
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {(+row?.FineWastageWt || 0)?.toFixed(3)}
                </td>
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {(+row?.MetalRate || 0)?.toFixed(2)}
                </td>
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {(+row?.StoneAmount || 0)?.toFixed(2)}
                </td>

                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {row?.Qty}
                </td>
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {(+row?.Hallmark || 0)?.toFixed(2)}
                </td>
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {(+row?.TotalItemAmount || 0)?.toFixed(2)}
                </td>
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {(+row?.PackingWeight || 0)?.toFixed(3)}
                </td>
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {(+row?.DiamondWeight || 0)?.toFixed(3)}
                </td>
              </tr>
            ))}
            <tr>
              <td>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    fontSize: "12px",
                    gap: "5px",
                  }}
                >
                  <div></div>
                  <div
                    style={{ display: "flex", flexDirection: "column" }}
                    title="add more"
                  >
                    <Icon
                      icon="weui:add-outlined"
                      onClick={() => {
                        // reset
                        setEdit(false);
                        setIsSummaryOpen(false);
                      }}
                      width="15"
                      height="15"
                      style={{ color: "#627282", cursor: "pointer" }}
                    />
                  </div>
                </div>
              </td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
            </tr>
            <tr>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              >
                Total
              </td>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              >
                {total?.TotalWt?.toFixed(3)}
              </td>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              >
                {total?.TotalGrossWt?.toFixed(3)}
              </td>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              >
                {total?.TotalStoneWt?.toFixed(3)}
              </td>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              >
                {total?.TotalNetWt?.toFixed(3)}
              </td>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              >
                {/* {total?.TotalFinePercent?.toFixed(2)} */}
              </td>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              >
                {/* {total?.TotalWastagePercent?.toFixed(2)} */}
              </td>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              >
                {total?.TotalFineMetal?.toFixed(3)}
              </td>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              >
                {/* {total?.TotalRate?.toFixed(2)} */}
              </td>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              >
                {total?.TotalStoneAmount?.toFixed(2)}
              </td>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              >
                {total?.TotalQty}
              </td>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              >
                {total?.TotalHallmark?.toFixed(2)}
              </td>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              >
                {total?.TotalItemAmount?.toFixed(2)}
              </td>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              >
                {total?.TotalPackingWt?.toFixed(3)}
              </td>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              >
                {total?.TotalDiamondWt?.toFixed(3)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Summary;
